import { useEffect, useState } from "react";
import { ContenidoInterno } from "../components/ContenidoInterno";
import styles from "../css/components/MenuInterno.module.css";
import { SinDatos } from "../components/SinDatos";

export function VistaInt({ datos }) {
  const [datosInternos, setDatosInternos] = useState([]);

  useEffect(() => {
    if (datos[0].datos[0].desc !== '' && datos[0].datos[0].file !== '') setDatosInternos(datos[0].datos);
  }, [datos]);

  function ocultarMostrar() {
    if (document.getElementById("menu").style.left === "-100%")
      document.getElementById("menu").style.left = "0%";
    else document.getElementById("menu").style.left = "-100%";
  }

  return (
    <div className={styles.prueba}>
      <header>
        <div>
          <label onClick={ocultarMostrar}>
            <ion-icon name="menu" />
          </label>
        </div>
        <nav id="menu" className={styles.menuInterno} style={{ left: "-100%" }}>
          {datos.map((dato) => {
            return (
              <div
                key={Math.random()}
                className={styles.containerInterno}
                onClick={function () {
                  if (dato.datos[0].desc !== '' && dato.datos[0].file !== '') {
                    setDatosInternos(dato.datos);
                    ocultarMostrar();
                  }
                }}
              >
                <div className={styles.containerIcon}>
                  <ion-icon name={dato.icon}></ion-icon>
                </div>
                <h3>{dato.title}</h3>
              </div>
            );
          })}
        </nav>
      </header>
      {(datosInternos.length > 0 ) ? (
        <ContenidoInterno datosInternos={datosInternos} />
      ) : (
        <SinDatos />
      )}
    </div>
  );
}
